// SelectableCard.js
import React from 'react';
import { Card } from 'react-bootstrap';

function SelectableCard({
  label,
  value,
  selectedValue,
  onChange,
  multiple = false
}) {
  // For multi-select, selectedValue is a boolean (true/false)
  const isSelected = multiple ? selectedValue : selectedValue === value;

  // Split label by em dash to create header and detail
  const splitLabel = (text) => {
    const emDashPattern = /\s*—\s*/;
    const parts = text.split(emDashPattern);
    
    if (parts.length >= 2) {
      return {
        header: parts[0].trim(),
        detail: parts.slice(1).join(' — ').trim()
      };
    }
    
    return { header: text, detail: null };
  };

  const { header, detail } = splitLabel(label);

  return (
    <Card
      onClick={() => onChange(value)}
      className={`selectable-card ${isSelected ? 'selected' : ''}`}
      role="button"
      tabIndex={0}
    >
      <Card.Body>
        <Card.Text as="div" className="selectable-card__body">
          {multiple && (
            <input
              type="checkbox"
              checked={isSelected}
              readOnly
              className="selectable-card__checkbox"
            />
          )}
          <div className="selectable-card__content">
            <div className="selectable-card__header">
              {header}
            </div>
            {detail && (
              <div className="selectable-card__detail">
                {detail}
              </div>
            )}
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default SelectableCard;
